import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';
import { createPolicyTipsPeekInfoBarAction } from 'owa-policy-tips/lib/utils/createPolicyTipsPeekInfoBarAction';
import { createPolicyTipsShowDetailsInfoBarAction } from 'owa-policy-tips/lib/utils/createPolicyTipsShowDetailsInfoBarAction';
import { getHighestPriorityPolicyTipMatchDetail } from './getHighestPriorityPolicyTipMatchDetail';
import { isOverrideLinkVisible } from './isOverrideLinkVisible';
import { MessagePart } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export function getPolicyTipsCustomAction(
    policyTipsViewState: PolicyTipsViewState,
    allRecipients: EmailAddressWrapper[],
    removeRecipientsFromWells: (wrappers: EmailAddressWrapper[]) => void
): MessagePart {
    const matchDetail = getHighestPriorityPolicyTipMatchDetail(
        policyTipsViewState.succeededPolicyMatch
    );
    if (matchDetail) {
        if (
            ((matchDetail.Recipients && matchDetail.Recipients.length > 0) ||
                isOverrideLinkVisible(matchDetail)) &&
            !policyTipsViewState.isOverridden
        ) {
            return createPolicyTipsShowDetailsInfoBarAction(
                policyTipsViewState,
                email => {
                    const filteredRecipients = allRecipients.filter(
                        emailWrapper => emailWrapper.EmailAddress == email
                    );
                    return filteredRecipients.length > 0 ? filteredRecipients[0] : null;
                },
                removeRecipientsFromWells
            );
        } else {
            return createPolicyTipsPeekInfoBarAction(policyTipsViewState);
        }
    } else {
        return null;
    }
}
